import { cx } from './cx';

export interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  className?: string;
}

export function Sparkline({ data, width = 60, height = 18, className }: SparklineProps) {
  if (data.length === 0) return null;
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const stepX = data.length > 1 ? width / (data.length - 1) : 0;
  const points = data
    .map((v, i) => `${i * stepX},${height - ((v - min) / range) * height}`)
    .join(' ');
  const fill = `0,${height} ${points} ${width},${height}`;
  return (
    <svg width={width} height={height} className={cx('overflow-visible', className)}>
      <polygon className="spark-fill" points={fill} />
      <polyline className="spark-line" points={points} />
    </svg>
  );
}

// Deterministic 14-point pseudo-series so different cells get distinct shapes.
export function makeSpark(seed: number, base = 10): number[] {
  let s = seed;
  const out: number[] = [];
  for (let i = 0; i < 14; i++) {
    s = (s * 9301 + 49297) % 233280;
    out.push(Math.max(0, Math.round(base + (s / 233280 - 0.5) * base * 0.8)));
  }
  return out;
}
